import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import * as _ from 'lodash';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { ReportService } from '../../../../../../core/services/report.service';

@Component({
  selector: 'app-sms-history-report',
  templateUrl: './sms-history-report.component.html',
  styleUrls: ['./sms-history-report.component.scss'],
  animations: [
    trigger('detailExpand', [
        state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
        state('*', style({height: '*', visibility: 'visible'})),
        transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class SmsHistoryReportComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  subscription: Subscription;
  enterpriseId;
  checkFocus = true;
  dateErr = '';
  mode = 12;
  isShowWarningSelectedFromDate: boolean = false;
  isShowWarningSelectedToDate: boolean = false;

  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;

  form: FormGroup;
  exportForm: any;
  showSpinner = false;
  constructor(
      private formBuilder: FormBuilder,
      public commonService: CommonService,
      public message: Message,
      public reportService: ReportService,
  ) {
      super(commonService, message);
  }

  ngOnInit() {
      this.enterpriseId = localStorage.getItem('enterpriseId');
      window.scrollTo(0, 0);

      this.form = this.formBuilder.group({
          fromDate: [null, [Validators.required]],
          toDate: [null, [Validators.required]],
          timePeriod: ['day', Validators.required]
      });
      const maxAllowCreatedTimeFrom = moment(Date.now()).subtract(31, 'd');
      this.formControls.toDate.setValue(moment(Date.now()).format('YYYY-MM-DD'));
      this.formControls.fromDate.setValue(maxAllowCreatedTimeFrom.format('YYYY-MM-DD'));
  }

  ngAfterViewInit(page: number = 0) {
      setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
  }

  /**
   * Get data when init
   */
  loadData() {
  }

  onExportReport() {
      if (this.form) {
          this.exportForm = {
            totalReportSearch: {
              fromDate: this.formControls.fromDate.value,
              toDate: this.formControls.toDate.value,
              timePeriod: this.formControls.timePeriod.value,
            }
          };
      }
  }

  get formControls() {
      return this.form.controls;
  }

  changeDatePickerFromDate(event) {
      this.isShowWarningSelectedToDate = false;
      this.isShowWarningSelectedFromDate = false;
      if (event.value != null) {
          const currentToDate = moment(this.formControls.toDate.value);
          const maxAllowCreatedTimeTo = moment(event.value).add(31, 'd');
          if (!currentToDate.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
              this.formControls.toDate.setValue(maxAllowCreatedTimeTo.format('YYYY-MM-DD'));
          }
      }
  }

  changeDatePickerToDate(event) {
      this.isShowWarningSelectedToDate = false;
      this.isShowWarningSelectedFromDate = false;
      if (event.value != null) {
          const currentFromDate = moment(this.formControls.fromDate.value);
          const maxAllowCreatedTimeFrom = moment(event.value).subtract(31, 'd');
          if (!currentFromDate.isBetween(maxAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
              this.formControls.fromDate.setValue(maxAllowCreatedTimeFrom.format('YYYY-MM-DD'));
          }
      }
  }

  getErrorDateMessageRange(pickerInput: string, _isExpired?: boolean): string {
    if (!pickerInput || pickerInput === '') {
      return '';
    }
    return this.message.getMessage('validation.format_of_date_consumption');
  }


  filterForm(event: any){
      const search = event.totalReportSearch || event;
      this.form.setValue({
          fromDate: moment(search.fromDate).format('YYYY-MM-DD'),
          toDate: moment(search.toDate).format('YYYY-MM-DD'),
          timePeriod: search.timePeriod,
      });
      window.scrollTo(0, 0);
  }
  
}
